import React, { useState } from 'react';

interface HelpAccordionProps {
  title: string;
  children: React.ReactNode;
}

const HelpAccordion: React.FC<HelpAccordionProps> = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="border-b border-gray-200 last:border-b-0">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="w-full flex justify-between items-center py-4 text-left text-lg font-semibold text-gray-800 hover:bg-gray-50 px-2 rounded-t-md"
                aria-expanded={isOpen}
            >
                <span>{title}</span>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={`h-6 w-6 transition-transform transform text-gray-500 ${isOpen ? 'rotate-180' : 'rotate-0'}`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
            </button>
            <div 
                className={`grid transition-all duration-300 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}
            >
                <div className="overflow-hidden">
                    <div className="p-4 text-gray-700 leading-relaxed bg-gray-50 rounded-b-md">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HelpAccordion;